const _ = require('lodash');
const UrlInfo = require('../urlinfo/url-info.js');

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            pageSize: '=',
            totalCount: '=',
            onPageSelect: '&',
            updateUrl: '=?'
        },
        bindToController: true,
        controllerAs: 'pagingController',
        controller: ['$scope', '$element', '$state', '$window', function ($scope, $element, $state, $window) {
            this.$onInit = function() {
                if (this.updateUrl === undefined) {
                    this.updateUrl = false;
                }

                this.urlInfo = new UrlInfo();

                this.setPageNumber = function (pageNumber, shouldInvokeCallback) {
                    this.currentPage = pageNumber;

                    if (shouldInvokeCallback) {
                        this.onPageSelect({ pageNumber });
                    }

                    this.showPreviousButton = this.currentPage !== 1;
                    this.showNextButton = this.currentPage !== this.pageNumbers.length;


                    $window.scrollTo(0, 0);

                    return pageNumber;
                };

                this.init = function () {
                    this.currentPage = parseInt($state.params.pageNumber, 10) || 1;
                    this.totalCount = this.totalCount || 0;
                    this.shouldDisplay = this.pageSize < this.totalCount;
                    this.pageNumbers = _.range(1, Math.ceil(this.totalCount / this.pageSize) + 1);
                    this.showPreviousButton = this.currentPage !== 1;
                    this.showNextButton = this.currentPage !== this.pageNumbers.length;
                };

                this.previousUrl = function () {
                    return this.pageUrl(this.currentPage - 1);
                };

                this.nextUrl = function () {
                    return this.pageUrl(this.currentPage + 1);
                };

                this.pageUrl = function (pageNumber) {
                    const params = (this.updateUrl) ? { pageNumber } : {};
                    return this.urlInfo.search(params, true);
                };

                this.transitionToPage = function () {
                    if (this.updateUrl) {
                        $state.params.pageNumber = this.currentPage;
                        $state.transitionTo($state.$current.self.name, $state.params, { location: true, inherit: true, notify: false });
                    }
                };

                this.pageClick = function (pageNumber) {
                    this.setPageNumber(pageNumber, true);
                    this.transitionToPage();
                };

                this.previousClick = function () {
                    this.setPageNumber(this.currentPage - 1, true);
                    this.transitionToPage();
                };

                this.nextClick = function () {
                    this.setPageNumber(this.currentPage + 1, true);
                    this.transitionToPage();
                };
            }.bind(this);
        }
        ],
        link(scope, element, attrs, ctrl) {
            ctrl.init();
        },
        template: require('./paging-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/paging/paging-directive.js
 **/